import React from 'react';
import { faCalendar, faClock } from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import './css/Events.css'

export default function Events(){

    return (
        <div>
            <section className="pb-0 events section-padding section-bg" id="events">
                <div className="container">
                    <div className="row" data-aos="zoom-in" data-aos-delay="100">
                        <div className="col-md-12 text-center">
                            <h1 className="section-title-dark">Our Events</h1>
                            <br/>
                        </div>
                    </div>
                    <div className="row mb-5" data-aos="fade-bottom" data-aos-delay="100">
                        <div className="col-md-6 col-sm-12 col-xs-12 mb-5 left-event text-center">
                            <div className="card shadow-sm background-muted-color card-message">
                                <div className="card-body">
                                    <h2 className="section-subtitle mb-5">Ceremony</h2>
                                    <div className="row">
                                        <div className="col-lg-12 mb-3">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <span className="section-item">Saturday, March 06 <sup>th</sup> 2021</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-5">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <h2 className="section-item"><br/></h2>
                                                    <span className="section-item">08:00 – 10:00 </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-2">
                                            <a rel="noopener noreferrer" target="_blank" href="https://calendar.google.com/event?action=TEMPLATE&tmeid=M2ZxZ2poY2psc2loaHNqdDNjY3FhYW1ua3IgcmlqYWxwZXJtYW5hMDBAbQ&tmsrc=rijalpermana00%40gmail.com">
                                                <span className='btn btn-sm btn-primary'>
                                                    Add To Calendar
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 mb-5 right-event text-center">
                            <div className="card shadow-sm background-muted-color card-message">
                                <div className="card-body">
                                    <h2 className="section-subtitle mb-5">Reception </h2>
                                    <div className="row">
                                        <div className="col-lg-12 mb-3">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <span className="section-item">Saturday, March 06 <sup>th</sup> 2021</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-5">
                                            <div className="row">
                                                {/* <div className="col-6 text-center">
                                                    <h2 className="section-item">First Session</h2>
                                                    <span className="section-item">11:00 – 12:30 </span>
                                                </div> */}
                                                <div className="col-12 text-center">
                                                    <h2 className="section-item">Second Session</h2>
                                                    <span className="section-item">12:30 – 14:00 </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-2">
                                            <a rel="noopener noreferrer" target="_blank" href="https://calendar.google.com/event?action=TEMPLATE&tmeid=NG05NHJlODhwa2MwcnJoNzRxOGlqamsxMzggcmlqYWxwZXJtYW5hMDBAbQ&tmsrc=rijalpermana00%40gmail.com">
                                                <span className='btn btn-sm btn-primary'>
                                                    Add To Calendar
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}